import Navigation from '../../components/layout/Navigation';
import Footer from '../../components/layout/Footer';
import HeroSection from './components/HeroSection';
import CTA from '../../components/ui/CTA';
import EvolutionSection from './components/EvolutionSection';
import PhilosophySection from './components/PhilosophySection';
import ServicesSection from './components/ServicesSection';
import TeamEmpowermentSection from './components/TeamEmpowermentSection';
import ContentFutureSection from './components/ContentFutureSection';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-black text-white overflow-x-hidden">
      <Navigation />
      <main>
        <HeroSection scrollY={0} />
        <EvolutionSection />
        <PhilosophySection />
        <ServicesSection />
        <TeamEmpowermentSection />
        <ContentFutureSection />
        <CTA 
          title="Ready to Begin Your AI-Powered Transformation?"
          description="Let's Shape Your Digital Success Story. Partner with Hash Adz to drive measurable results."
          primaryBtn={{ text: "Explore Our Case Studies", link: "/news", icon: "ri-external-link-line" }}
          secondaryBtn={{ text: "Request a Proposal", link: "/contact", icon: "ri-calendar-line" }}
          gradient="from-gray-900 to-black"
          stats={[
            { number: '10+', label: 'Years Experience' },
            { number: '15000+', label: 'Orders Fulfilled' },
            { number: '110+', label: 'Brands Served' },
            { number: '3000+', label: 'Logos Created' }
          ]}
        />
      </main>
      <Footer />
    </div>
  );
}